import InitSlider from './init-slider';
import Zoom from './zoom';
import Video from './video';

theme.mediaInstances = {};

const selectors = {
  videoPlayer: '[data-video]',
  modelViewer: '[data-model]',
  sliderEnabled: 'flickity-enabled',
  classMediaHidden: 'media--hidden',
};

class Media {
  constructor(section) {
    this.section = section;
    this.id = section.id;
    this.container = section.container;
  }

  init() {
    new Video(this.section);

    this.detect3d();
    this.launch3d();

    new Zoom(this.section);
    new InitSlider(this.section);
  }

  detect3d() {
    const modelViewerElements = this.container.querySelectorAll(selectors.modelViewer);
    if (modelViewerElements.length) {
      modelViewerElements.forEach((element) => {
        theme.ProductModel.init(element, this.id);
      });
    }
  }

  launch3d() {
    const instance = this;

    document.addEventListener('shopify_xr_launch', function () {
      const currentMedia = instance.container.querySelector(`${instance.selectors.modelViewer}:not(.${selectors.classMediaHidden})`);
      currentMedia.dispatchEvent(new CustomEvent('xrLaunch'));
    });
  }
}

export default Media;
